import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { OccupationCard } from '@cpd-app/generated';

@Component({
  selector: 'cpd-occupation-scores-display',
  templateUrl: './occupation-scores-display.component.html',
  styleUrls: ['./occupation-scores-display.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OccupationScoresDisplayComponent {
  @Input() public occupation: OccupationCard;
  @Input() public isShowMatchScore = false;
  @Input() public disabled = false;

  public get noData(): boolean {
    return (
      this.disabled ||
      !this.occupation ||
      (!this.occupation.skillsMatchQualityId &&
        !this.occupation.interestsMatchQualityId &&
        !this.occupation.valuesMatchQualityId &&
        !this.occupation.lifestyleMatchQualityId)
    );
  }
}
